import { observer } from 'mobx-react-lite'
import { useActivation } from '@/hooks/view-model-hooks'
import { type AdminTransactionHistoryViewModel } from '@/features/payouts/admin/transaction-history/AdminTransactionHistoryViewModel'
import { TransactionHistory } from '@/features/payouts/admin/transaction-history/components/TransactionHistory'
import { HistoricalTransactionsTableContainer } from '@/features/payouts/admin/transaction-history/components/HistoricalTransactionsTable/HistoricalTransactionsTableContainer'

export interface TransactionHistoryContainerProps {
  vm: AdminTransactionHistoryViewModel
}

export const TransactionHistoryContainer = observer(
  function TransactionHistoryContainer({
    vm,
  }: TransactionHistoryContainerProps) {
    useActivation(vm)
    return (
      <TransactionHistory
        canAccess={vm.canAccessPayoutsAdministration}
        transactionsCount={vm.transactionsCount}
      >
        <HistoricalTransactionsTableContainer vm={vm} />
      </TransactionHistory>
    )
  },
)
